// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2IWOe","footer":"ModalUpdate_footer__2Ut4N"};